/**
 * This file contains shared non-Vanguard-specific/non-business-logic
 * utility types that can be shared across the project
 */

export type HTTPS = `https://${string}`;
export type HTTP = `http://${string}`;
